const CHAPORT_APP_ID = '69c3c490ea9d6e7426496307';
const CHAPORT_SCRIPT_SRC = 'https://app.chaport.ru/javascripts/insert.js';
function ensureChaportLoaded() {
    var _a;
    if (typeof window === 'undefined' || typeof document === 'undefined') {
        return;
    }
    window.chaportConfig = Object.assign(Object.assign({}, window.chaportConfig), { appId: CHAPORT_APP_ID, launcher: Object.assign(Object.assign({}, (_a = window.chaportConfig) === null || _a === void 0 ? void 0 : _a.launcher), { show: false }) });
    if (window.chaport) {
        return;
    }
    const chaport = {};
    chaport._q = [];
    chaport._l = {};
    chaport.q = function (...args) {
        if (chaport._q) {
            chaport._q.push(args);
        }
    };
    chaport.on = function (event, listener) {
        var _a, _b;
        if (!((_a = chaport._l) === null || _a === void 0 ? void 0 : _a[event])) {
            chaport._l = Object.assign(Object.assign({}, chaport._l), { [event]: [] });
        }
        if ((_b = chaport._l) === null || _b === void 0 ? void 0 : _b[event]) {
            chaport._l[event].push(listener);
        }
    };
    window.chaport = chaport;
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = CHAPORT_SCRIPT_SRC;
    const firstScript = document.getElementsByTagName('script')[0];
    if (firstScript === null || firstScript === void 0 ? void 0 : firstScript.parentNode) {
        firstScript.parentNode.insertBefore(script, firstScript);
        return;
    }
    document.head.appendChild(script);
}
function queueChaport(method, ...args) {
    ensureChaportLoaded();
    if (window.chaport) {
        window.chaport.q(method, ...args);
    }
}
export function initChaport() {
    ensureChaportLoaded();
}
export function setChaportVisitorData(data) {
    queueChaport('setVisitorData', data);
}
export function updateChaportPageContext(title, path) {
    queueChaport('setVisitorData', {
        custom: {
            currentPageTitle: title,
            currentPagePath: path
        }
    });
}
export function openChaportChat(data) {
    setChaportVisitorData(data);
    queueChaport('open');
}
